
import * as THREE from 'three';

export class GeometryHelper {
    static generateHipRoofGeometry(footprint: [number, number][], slopeDegrees: number): THREE.BufferGeometry {
        // Simple Pyramid generation for convex polygons (Hip Roof approximation)
        // 1. Calculate Centroid
        const center = new THREE.Vector2(0, 0);
        footprint.forEach(p => center.add(new THREE.Vector2(p[0], p[1])));
        center.divideScalar(footprint.length);

        // 2. Calculate Distance to nearest edge (to determine height)
        let minDist = Number.MAX_VALUE;
        for (let i = 0; i < footprint.length; i++) {
            const p1 = new THREE.Vector2(...footprint[i]);
            const p2 = new THREE.Vector2(...footprint[(i + 1) % footprint.length]);

            // Perpendicular distance from center to line segment p1-p2
            const line = new THREE.Line3(new THREE.Vector3(p1.x, p1.y, 0), new THREE.Vector3(p2.x, p2.y, 0));
            const closest = new THREE.Vector3();
            line.closestPointToPoint(new THREE.Vector3(center.x, center.y, 0), true, closest);
            const dist = closest.distanceTo(new THREE.Vector3(center.x, center.y, 0));
            if (dist < minDist) minDist = dist;
        }

        // 3. Calculate Peak Height
        const slopeRad = slopeDegrees * (Math.PI / 180);
        const height = Math.tan(slopeRad) * minDist;

        // 4. Construct Geometry (Triangle Fan)
        const vertices: number[] = [];
        const indices: number[] = [];

        // Base vertices (at z=0)
        footprint.forEach(p => {
            // Apply overhang roughly? For now, assume footprint INCLUDES overhang
            vertices.push(p[0], p[1], 0);
        });

        // Peak vertex
        vertices.push(center.x, center.y, height);
        const peakIndex = footprint.length;

        // Valid for convex polygons
        for (let i = 0; i < footprint.length; i++) {
            const next = (i + 1) % footprint.length;
            // Triangle: Current, Next, Peak
            indices.push(i, next, peakIndex);

            // Floor (optional, closing the bottom)
            // indices.push(next, i, ...centerIndex? No center point on bottom needed for rendering normally)
        }

        const geo = new THREE.BufferGeometry();
        geo.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
        geo.setIndex(indices);
        geo.computeVertexNormals();

        return geo;
    }
}
